module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapter 5: Brandon With Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE FOLLOWING")]), _vm._v(" Tuesday, when his last client of the day left, Brandon joined Ethan and several other friends at JR’s, a gay bar near the park where they would soon play kickball when the season started. The bar was long, narrow, and loud. A stained-glass window, high above the room, glowed in the street light from outside, while TV screens above the bar played music videos. Brandon squeezed into a corner with his beer, next to Ethan and two of their teammates, Scott and Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Where’s Colin?” he practically shouted over the din.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ethan leaned over to speak into his ear. “He had to work tonight. He texted right before you got here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Maybe he’s avoidin’ you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s playing hard to get. But I will wear him down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t doubt that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How about you? Have you met anyone new and interesting?” Ethan asked. Unexpectedly Brandon pictured David, his new client, who had been in a few times.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” he answered. “I went over to some rando’s apartment last week, though. Had to make sure my junk was still in workin’ order, since it’s been so long.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hah. That’s my slutty friend. Was he good smash?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not really, but he was at least hung.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good Lord. You size queens are all alike,” Tom said, joining the conversation. “What difference does an extra inch or two make in the scheme of things?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ethan and Brandon looked at each other and yelled together, “Everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tom laughed with them but said, “I’d still rather meet a nice guy with a small dick than go out with a mook just because he has a log between his legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ethan pushed his glasses up on the bridge of his nose and said seriously to Tom, “You know, I read somewhere recently that eight out of ten gay men agree that size matters… and the other two are lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tom teasingly pushed Ethan away, and he fell against Brandon, which made him slosh his beer.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry about that,” Ethan apologized as he grabbed a napkin and turned to mop up the spill on Brandon’s shirt. “Anyhoo, give me something to enliven my dull life while I wait for Colin to come around,” he said as he dabbed, maybe a bit longer than was necessary. “What about the rando?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nothing really to tell, sad to say. I went over, we did it, I left.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Boo. A man who looks like you should have the pick of the litter.” Ethan looked around the bar. “There’s the litter. Go pick.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Brandon laughed at that and scanned the crowd—all ages, all body types. There were a few stunners here and there, of course paired up already, but mainly just people having a good time. He loved being there, even if there wasn’t anyone available who caught his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He surprised himself by saying to Ethan, “There was a new client last week. No. Two weeks ago now. Shoulder tear. He was really good-lookin’—all suited up like a DC power type. I think he’s gay, but I’m not quite sure yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ooh. Now that could be promising. More deets, please—young, old, tall, skinny, white, black, other?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’d say late thirties, maybe forty. White guy, nice hair. And he looked good with his shirt off.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Half-naked men on the job, and you get "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("paid")]), _vm._v(" to fondle them. What am I doing at Lambda Law Fund? The only cute ones are the interns, and they don’t stick around long enough to see the real me.” Ethan gestured grandly at his own body.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was a big one, well, in the belly at least. Okay, fat. Ethan’s glasses constantly slipped down his nose, and his bushy hair stood out in all directions. Not what you’d call handsome, but Brandon thought he had a heart of gold. Ethan was one of the first gay people he met when he moved up from Texas, and he brought Brandon into the kickball league the previous season.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So, did you hit on the suit?” Ethan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nah. I told you, I’m not sure he’s even gay.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He sounds like a DILF.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A DILF. Daddy I’d Like to Fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m not lookin’ for a daddy,” Brandon said, suddenly a bit uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, honey. Aren’t we all looking for a daddy? Someone older and rich who can take us away from all this?” Ethan gestured again at the crowd around the gay bar.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m not. I like it here just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ethan shook his head. “Your looks won’t last forever. Strike while the iron is hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Brandon didn’t like the turn the conversation had taken, so he shifted his focus to Tom. When Ethan spotted another friend and tottered off to chat with him, Brandon was relieved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3511a36c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0009.vue
// module id = 81
// module chunks = 0